import { Workspace } from "@zirp/client";
import { useApi } from "../useApi";
import { useAuth } from "../auth/useAuth";
import { useGetWorkspace } from "./useGetWorkspace";

export const useListWorkspaces = () => {
  const workspaceId = useCookie("workspace_id");
  const loading = useState<boolean>("listWorkspaces:loading", () => false);
  const error = useState<string | null>("listWorkspaces:error", () => null);
  const workspaces = useState<Workspace[]>("listWorkspaces:workspaces", () => []);
  const api = useApi();

  const { authRequest } = useAuth();
  const route = useRoute();
  const workspace_slug = computed(() => route.params.workspace_slug);
  const { workspace } = useGetWorkspace();

  const listWorkspaces = async () => {
    try {
      error.value = null;
      loading.value = true;

      const response = await authRequest(async () => await api.workspaces.workspacesList());
      if (response?.success) {
        workspaces.value = response.result;

        if (workspace_slug.value && workspaces.value?.some((w) => w.slug === workspace_slug.value)) {
          const w = workspaces.value?.find((w) => w.slug === workspace_slug.value);
          workspace.value = w;
          workspaceId.value = w.id;
          return response.result;
        }

        if (workspaceId.value && workspaces.value?.some((w) => w.id === workspaceId.value)) {
          const w = workspaces.value?.find((w) => w.id === workspaceId.value);
          workspace.value = w;
          return response.result;
        }

        if (workspaces.value?.length > 0) {
          workspace.value = workspaces.value[0];
          workspaceId.value = workspace.value.id;
          return;
        }

        return response.result;
      }
    } catch (err) {
      error.value = "Failed to list workspaces";
      throw err;
    } finally {
      loading.value = false;
    }
  };

  return {
    listWorkspaces,
    loading,
    error,
    workspaces,
  };
};
